var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglelogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4132 14.1197H24.6399V14.0799H15.9999V17.9199H21.4253C20.6338 20.1553 18.5069 21.7599 15.9999 21.7599C12.8189 21.7599 10.2399 19.1809 10.2399 15.9999C10.2399 12.8189 12.8189 10.2399 15.9999 10.2399C17.4682 10.2399 18.8041 10.7938 19.8212 11.6986L22.5365 8.98326C20.822 7.38534 18.5285 6.3999 15.9999 6.3999C10.6983 6.3999 6.3999 10.6983 6.3999 15.9999C6.3999 21.3015 10.6983 25.5999 15.9999 25.5999C21.3015 25.5999 25.5999 21.3015 25.5999 15.9999C25.5999 15.3562 25.5337 14.7279 25.4132 14.1197Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50684 11.5316L10.6609 13.8447C11.5144 11.7317 13.5812 10.2399 16 10.2399C17.4683 10.2399 18.8041 10.7938 19.8212 11.6986L22.5366 8.98326C20.822 7.38534 18.5286 6.3999 16 6.3999C12.3126 6.3999 9.11484 8.48166 7.50684 11.5316Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5994C18.4797 25.5994 20.7328 24.6504 22.4363 23.1072L19.4651 20.593C18.5013 21.3231 17.3032 21.7594 16 21.7594C13.5031 21.7594 11.3829 20.1672 10.5842 17.9453L7.45361 20.3573C9.04241 23.4663 12.269 25.5994 16 25.5994Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4133 14.118H24.64V14.0781H16V17.9181H21.4254C21.0453 18.9919 20.3546 19.9178 19.4637 20.5922L19.4651 20.5912L22.4363 23.1055C22.2261 23.2965 25.6 20.7981 25.6 15.9981C25.6 15.3544 25.5338 14.7261 25.4133 14.118Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelogin);
export default __webpack_public_path__ + "static/media/googlelogin.e3ee998162af733b5ad683bba4ef91ee.svg";
export { ForwardRef as ReactComponent };